﻿<div class="route-component">
    <tab-control>

        <tab-page title="Details" icon="fas fa-user-pen">
            <div class="form-component">
                <h4 *ngIf="userRoleId > 0">
                    Edit user role
                </h4>

                <h4 *ngIf="userRoleId === 0">
                    Create new user role
                </h4>

                <form #form="ngForm" (ngSubmit)="onSave(form)">
                    <div class="input-group">
                        <label for="description">
                            Description:<span class="required"> * </span>
                        </label>
                        <div>
                            <input name="Description" #description="ngModel" type="text" placeholder="Description" [class.invalid]="description.invalid" [(ngModel)]="userRole.description" required>
                            <div *ngIf="description.invalid">
                                <span class="error">Role description is required</span>
                            </div>
                        </div>
                    </div>

                    <div class="action-bar">
                        <button type="submit" class="button" [disabled]="form.invalid || isSaving">
                            <span *ngIf="isSaving" class="loading-spinner"></span>
                                <i *ngIf="!isSaving" class="fas fa-save"></i>
                            Save
                        </button>
                        <button type="button" class="button-cancel" (click)=" onCancel()">
                            <i class="fas fa-cancel"></i> Cancel
                        </button>
                    </div>
                </form>
            </div>
        </tab-page>

        <ng-container *ngFor="let group of groupedConstants">
            <tab-page *ngIf="userRoleId > 0" [title]="group.titleTab" icon="fas fa-solid fa-user-shield">
                <div class="form-component">
                    <form (ngSubmit)="savePermissions(group)">

                        <h4>
                            {{ group.titlePage }}
                        </h4>

                        <table class="permissions-table">
                            <thead>
                                <tr>
                                    <th class="text-left-align" style="text-align: left;" style="width: 150px;">Area</th>
                                    <th class="text-center-align" *ngFor="let permission of group.permissions" style="width: 150px;">
                                        {{ permission }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let area of group.areas">
                                    <td class="text-left-align">{{ area.name }}</td>
                                    <td class="text-center-align" *ngFor="let permission of group.permissions">
                                        <switch-control
                                            [(ngModel)]="area.permissions[permission]"
                                            (onChange)="onPermissionChange(area, permission)"
                                            [name]="'permission-' + area + '-' + permission"
                                            [label]="permission">
                                        </switch-control>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <div class="action-bar">
                            <button type="submit" class="button" [disabled]="form.invalid || isSaving">
                                <span *ngIf="isSaving" class="loading-spinner"></span>
                                    <i *ngIf="!isSaving" class="fas fa-save"></i>
                                Save
                            </button>
                            <button type="button" class="button-cancel" (click)=" onCancel()">
                                <i class="fas fa-cancel"></i> Cancel
                            </button>
                        </div>

                    </form>
                </div>
            </tab-page>
        </ng-container>

    </tab-control>
</div>